import type { RelayControlRecoverySummary } from "@cmmd-forge/client-runtime";
import { AlertTriangleIcon, Loader2Icon, XIcon } from "lucide-react";

export interface RelayControlRecoveryRowProps {
  readonly summary: RelayControlRecoverySummary | null;
  readonly onAcknowledge: () => void;
}

function recoveryLabel(summary: RelayControlRecoverySummary): string {
  const plural = summary.count === 1 ? "action" : "actions";
  switch (summary.state) {
    case "pending":
      return `Sending ${summary.count} remote ${plural}`;
    case "retrying":
      return `Retrying ${summary.count} remote ${plural}`;
    case "outcome-unknown":
      return `${summary.count} remote ${plural}: outcome unknown`;
    case "failed":
      return `${summary.count} remote ${plural} failed`;
    case "idle":
      return "";
  }
}

export function RelayControlRecoveryRow(props: RelayControlRecoveryRowProps) {
  if (props.summary === null || props.summary.state === "idle") return null;
  const actionable = props.summary.state === "failed" || props.summary.state === "outcome-unknown";
  const Icon = actionable ? AlertTriangleIcon : Loader2Icon;
  return (
    <div
      className="mx-2 flex h-7 min-w-0 items-center gap-2 border-l border-border/50 px-3 text-[11px] text-muted-foreground"
      role={actionable ? "alert" : "status"}
    >
      <Icon
        aria-hidden="true"
        className={actionable ? "size-3.5 shrink-0 text-warning" : "size-3.5 shrink-0 animate-spin"}
      />
      <span className="min-w-0 flex-1 truncate">{recoveryLabel(props.summary)}</span>
      {actionable ? (
        <button
          type="button"
          className="flex size-6 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground"
          aria-label="Acknowledge remote action outcome"
          title="Acknowledge"
          onClick={props.onAcknowledge}
        >
          <XIcon aria-hidden="true" className="size-3.5" />
        </button>
      ) : null}
    </div>
  );
}
